<template>
  <v-dialog :value="value" width="400" persistent>
    <v-card>
      <v-card-title>Move to another account</v-card-title>

      <v-card-text>

        <p><b>This will move the product to an existing billing account.</b></p>

        <v-text-field v-model="account_search_text" label="Account Search" autofocus :loading="getMoveToAccountSearchLoading" :disabled="getMoveToAccountSearchLoading" @keyup.enter="doSearch" dense outlined hide-details>
          <template #append>
            <v-icon color="secondary" @click="doSearch">{{mdiMagnify}}</v-icon>
          </template>
        </v-text-field>

        <template v-if="showNoResults">
          <p class="error--text mt-4">No results found</p>
        </template>

        <template v-else>
          <v-radio-group v-model="account_chosen" column>

            <template v-for="(acc,ind) in getMoveToAccountSearch">
              <v-radio :key="ind" :label="`${acc.id} - ${acc.name}`" :value="acc.id" />
            </template>

          </v-radio-group>
        </template>


      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" small @click="submit" :disabled="disableOK" :loading="getMoveToAnotherAccountLoading">OK</v-btn>
        <v-btn color="primary" small outlined @click="close" :disabled="getMoveToAnotherAccountLoading">CLOSE</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions,mapGetters,mapMutations } from 'vuex';
  import { mdiMagnify } from '@mdi/js';

  const URL = process.env.VUE_APP_URL || `https://crm-bonline-testing.appspot.com/`;

  export default {

    data() {
      return {
        mdiMagnify,
        account_search_text: '',
        account_chosen: '',
      }
    },

    props: ['value'],

    computed: {
      ...mapGetters('moveToAccount',['getMoveToAccountSearch','getMoveToAccountSearched','getMoveToAccountSearchLoading','getMoveToAnotherAccountProductId','getMoveToAnotherAccount','getMoveToAnotherAccountLoading','getMoveToAnotherAccountError']),

      showNoResults(){
        return this.getMoveToAccountSearched && !this.getMoveToAccountSearch.length;
      },

      disableOK(){
        return this.account_chosen === '' || this.getMoveToAnotherAccountLoading;
      },
    },

    methods: {
      ...mapActions('moveToAccount',['SEARCH_ACCOUNT_TO_MOVE','MOVE_TO_ANOTHER_ACCOUNT']),
      ...mapActions('alerts', ['setAlert']),
      ...mapMutations('moveToAccount',['RESET_MOVE_TO_STORE']),

      doSearch(){
        this.SEARCH_ACCOUNT_TO_MOVE(this.account_search_text);
      },

      async submit() {
        await this.MOVE_TO_ANOTHER_ACCOUNT(this.account_chosen);

        if(!this.getMoveToAnotherAccountError){
          window.open(`${URL}accounts/${this.account_chosen}/`);
          // Snackbar to be used when we refactor the account page to use a proper store
          // this.setAlert({type: 'success', message: `${this.getMoveToAnotherAccountProductId} product has been moved to account: ${this.account_chosen}`});
          window.location.reload();
          this.close();
        }
      },

      close() {
        this.account_search_text = '';
        this.account_chosen = '';
        this.RESET_MOVE_TO_STORE();
        this.$emit('input', false);
      },
    },

  }
</script>

<style lang="scss" scoped></style>
